import { LocalStorageService, PERSISTENT_KEY_PREFIX } from '../../../services/local-storage-service';

const OLD_PRINT_SETTINGS_LOCAL_STORAGE_KEY = 'shipstation.printSettings';
const PRINT_SETTINGS_LOCAL_STORAGE_KEY = `${PERSISTENT_KEY_PREFIX}.shipstation.printSettings`;
const PRINT_WARNING_SETTINGS_LOCAL_STORAGE_KEY = `${PERSISTENT_KEY_PREFIX}.shipstation.printWarningSettings`;

export const readPrintSettings = () => {
  return (
    LocalStorageService.getItem(PRINT_SETTINGS_LOCAL_STORAGE_KEY) || LocalStorageService.getItem(OLD_PRINT_SETTINGS_LOCAL_STORAGE_KEY) || {}
  );
};

export const writePrintSettings = (printSettings) => {
  LocalStorageService.setItem(PRINT_SETTINGS_LOCAL_STORAGE_KEY, JSON.stringify(printSettings));
};

export const readPrintWarningSettings = () => {
  return LocalStorageService.getItem(PRINT_WARNING_SETTINGS_LOCAL_STORAGE_KEY) || {};
};

export const writePrintWarningSettings = (printWarningSettings) => {
  LocalStorageService.setItem(PRINT_WARNING_SETTINGS_LOCAL_STORAGE_KEY, JSON.stringify(printWarningSettings));
};
